//@flow
import React, { useState, useRef, useEffect, Fragment } from 'react';
import Slider from 'react-slick';

import ImgBox from '../Lightbox/ImgBox';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

type Props = {
  images: Array<string>,
  primaryImageUrl?: string,
  uploadedUrls?: typeof undefined | Array<string>,
  customPaging?: () => void,
  showNav: boolean,
};

const GalleryArrow = ({
  placement,
  onClick,
}: {
  placement: string,
  onClick: () => void,
}) => (
  <div className={`control ${placement}`}>
    <a onClick={onClick}>
      <div className="circle">
        <i className={`icon icon-hg-chev-${placement}`} />
      </div>
    </a>
  </div>
);

const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  lazyLoad: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  adaptiveHeight: false,
  nextArrow: <GalleryArrow placement="right" />,
  prevArrow: <GalleryArrow placement="left" />,
};

const navSettings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 13,
  slidesToScroll: 1,
  centerPadding: "60px",
  centerMode: true,
  className: "center",
  adaptiveHeight: true,
  nextArrow: <GalleryArrow placement="right" />,
  prevArrow: <GalleryArrow placement="left" />,
  responsive: [
    { breakpoint: 1026, settings: { slidesToShow: 11 } },
    { breakpoint: 991, settings: { slidesToShow: 9} },
    { breakpoint: 600, settings: { slidesToShow: 5, slidesToScroll: 1,} },
    { breakpoint: 480, settings: { slidesToShow: 5, slidesToScroll: 1,} }
  ],
};

const  getThumbnailUrl = str => str.indexOf('_bl') !== -1 ? str.replace(/_bl\.jpeg/, '_cs.jpeg') : str.replace(/\.jpeg/, '_cs.jpeg');

export default function JumbotronImageSlider({
  images,
  uploadedUrls,
  primaryImageUrl,
  customPaging,
  showNav,
}: Props) {
  images = images ? images : [];
  const allImages = uploadedUrls ? [...uploadedUrls, ...images] : images;

  const [state, setState] = useState({ nav1: null, nav2: null });
  const slider1 = useRef();
  const slider2 = useRef();

  // if (customPaging) settings.customPaging = customPaging;

  useEffect(() => {
    setState({
      nav1: slider1.current,
      nav2: slider2.current,
    });
  }, []);

  const { nav1, nav2 } = state;


  return (
    <Fragment>
    <Slider
      {...settings}
      className={`gallery ${customPaging ? 'gallery--customPaging' : ''}`}
      asNavFor={nav2} ref={slider => (slider1.current = slider)}
    >
      {allImages.map((image, index) => {
        // Return loading if on image
        if (!image) return null;
        return (
          <div className="gallery-item" key={image}>
            <div className="item-wrap">
              <ImgBox
                src={image}
                srcIndex={index}
                images={allImages}
                primaryImageUrl={primaryImageUrl}
              />
              {image.caption && (
                <div className="gallery-caption">
                  <p>{image.caption}</p>
                </div>
              )}
            </div>
          </div>
        );
      })}
    </Slider>
    {
      showNav && (
        <Slider
          {...navSettings}
          asNavFor={nav1}
          className="gallery-nav"
          focusOnSelect={true}
          ref={slider => (slider2.current = slider)}
        >
          {allImages.map((image) => {
            console.log('image', image);
            if (!image) return null;
            return (
              <div className="gallery-nav-item">
                <img
                key={image}
                src={getThumbnailUrl(image)}
                alt=""
              />
              </div>
            );
          })}
        </Slider>
      ) 
    }
    </Fragment>
  );
}


// WEBPACK FOOTER //
// ./src/components/JumbotronImageSlider/JumbotronImageSlider.jsx